package com.example.mystybag.login.views.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

/** Same width as web auth forms (`EnterEmailViewWeb`, `MerchantLoginViewWeb`). */
val MerchantRegistrationWebContentColumnWidth = 530.dp

/**
 * Web registration: centered column under the app bar (same width as merchant/staff sign-in web).
 */
@Composable
fun MerchantRegistrationWebBoundedColumn(
    modifier: Modifier = Modifier,
    content: @Composable ColumnScope.() -> Unit
) {
    Box(
        modifier = modifier.fillMaxWidth(),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier
                .width(MerchantRegistrationWebContentColumnWidth)
                .fillMaxSize(),
            horizontalAlignment = Alignment.Start
        ) {
            content()
        }
    }
}
